<template>
	<ListItem
		is-recipient
		:custom-text="text"
	/>
</template>
<script>
import ListItem from "@/vue/communication/conversation/message/ListItem.vue";
import {mapState} from "vuex";

export default {
	components: {
		ListItem
	},

	props: {
		customer: {
			type: Object,
			required: false,
		},
	},

	computed: {
		...mapState('auth', ['application']),
		text ()
		{
			if (!this.application)
			{
				return '';
			}

			let text = '<div class="font-weight-bold mb-1">Du bist noch anonym!</div>';
			text += '<div class="mb-1">Der Job ist noch nicht besetzt!</div>';
			text += '<div class="mb-3">Um Hintergrundinformationen zur Stelle zu erfahren und deine Chancen zu sichern, bestätige bitte umgehend die Kontaktanfrage.</div>';
			text += '<div>Wenn du auf "Meine Daten senden" klickst, werden folgende Daten geteilt:</div>';
			text += '<div class="font-weight-bold">%name%<br/>%yearOfBirth%</div>';

			if (this.customer?.name)
			{
				text += '<div class="mt-3"><b>%customerName%</b> sendet dir dann Informationen für weitere Schritte.</div>';
			}

			text = text.replace('%name%', this.application.nameWithSalutation);
			text = text.replace('%yearOfBirth%', this.application.yearOfBirth);

			if (this.customer?.name)
			{
				text = text.replace('%customerName%', this.customer.name);
			}

			return text;
		}
	}
}
</script>
